module.exports = __webpack_public_path__ + "wgbh.052e2f1b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/logos/wgbh.png
// module id = NI+a
// module chunks = 0